import { Routes, Route, Navigate } from 'react-router-dom';
import { useAuthStore } from './stores/authStore';
import { LoginPage } from './pages/LoginPage';
import { DashboardLayout } from './components/DashboardLayout';
import { DashboardPage } from './pages/DashboardPage';
import { TenantsPage } from './pages/TenantsPage';
import { TenantDetailPage } from './pages/TenantDetailPage';
import { DocumentsPage } from './pages/DocumentsPage';
import { ConversationsPage } from './pages/ConversationsPage';
import { ChatTestPage } from './pages/ChatTestPage';
import { SettingsPage } from './pages/SettingsPage';
import { MonitoringPage } from './pages/MonitoringPage';
import { MonitoringTokensPage } from './pages/MonitoringTokensPage';
import { MonitoringTenantsPage } from './pages/MonitoringTenantsPage';
import { MonitoringLogsPage } from './pages/MonitoringLogsPage';
import { UsersPage } from './pages/UsersPage'; // [2026-03-21]

function PrivateRoute({ children }: { children: React.ReactNode }) {
  const isAuthenticated = useAuthStore((state) => state.isAuthenticated);
  return isAuthenticated ? <>{children}</> : <Navigate to="/login" replace />;
}

function App() {
  return (
    <Routes>
      <Route path="/login" element={<LoginPage />} />
      <Route
        path="/"
        element={
          <PrivateRoute>
            <DashboardLayout />
          </PrivateRoute>
        }
      >
        <Route index element={<DashboardPage />} />
        <Route path="tenants" element={<TenantsPage />} />
        <Route path="users" element={<UsersPage />} />
        <Route path="tenants/:id" element={<TenantDetailPage />} />
        <Route path="documents" element={<DocumentsPage />} />
        <Route path="conversations" element={<ConversationsPage />} />
        <Route path="chat-test" element={<ChatTestPage />} />
        <Route path="monitoring" element={<MonitoringPage />} />
        <Route path="monitoring/tokens" element={<MonitoringTokensPage />} />
        <Route path="monitoring/tenants" element={<MonitoringTenantsPage />} />
        <Route path="monitoring/logs" element={<MonitoringLogsPage />} />
        <Route path="settings" element={<SettingsPage />} />
      </Route>
      <Route path="*" element={<Navigate to="/" replace />} />
    </Routes>
  );
}

export default App;
